<template>
  <v-container fluid grid-list-xl>
    <v-card>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-side-icon><v-icon>movie</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>
          {{$tc('app.mixingConsole', 2)}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <span v-if="buttons.length == 0">{{ $t('app.pleaseAddDirectorFlags') }}</span>
        <v-layout row wrap>
          <v-btn large v-for="btn in buttons" x-large
            :key="btn.id" :outline="(btn.state == 1)" color="primary" flat
            @click.native="btn.state = 1-btn.state; setFlag(btn.id, btn.state)">
            {{ btn.name }}
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  components: {
  },
  data() {
    return {
      buttons: [
      ],
    };
  },
  mounted() {
    const vm = this;
    axios.get(`${window.api_url}api/director-flags?pagination=false`, {})
      .then((response) => {
        vm.buttons = response.data.data;
      })
      .catch((error) => {
        vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
      });
  },
  methods: {
    setFlag(id, value) {
      const vm = this;

      axios.patch(`${window.api_url}api/director-flag/${id}`, {
        state: value,
      })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
  },
};
</script>
<style scoped>

</style>
